import { SearchForm } from "mixs/base/search_mixin";
import { PlannerSearch } from "mixs/forms/planner/search";
import { get } from "apps/actions/common"

class Search extends PlannerSearch {
}

riot.mixin("forms.orders.search", Search as riot.TagMixin);
